import { TableBadgeLabel } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { invoiceStatusToBadgeColor } from '../../../../../../constants/invoiceStatusToBadgeVariant'
import { InvoiceStatus } from '../../../../../../enums/invoiceStatus'
import { useInvoicesListFilters } from '../../../../context/invoicesListFilters'
import { useInvoicesSummaryFiltered } from './hooks/useInvoicesSummaryFiltered'
import { getInvoicesTitle } from './utils/getInvoicesTitle'

export const InvoicesTitle = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, data } = useInvoicesSummaryFiltered()
  const [filters] = useInvoicesListFilters()

  const status = filters?.status || InvoiceStatus.All
  const totalAmount = !data ? 0 : data?.[status].count
  const title = getInvoicesTitle(status, totalAmount, t)
  const variant = invoiceStatusToBadgeColor[status]

  return (
    <TableBadgeLabel amount={totalAmount} isLoading={isLoading} color={variant}>
      {title}
    </TableBadgeLabel>
  )
}
